var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumberOneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833313 10C0.833313 4.91667 4.91665 0.833336 9.99998 0.833336C15.0833 0.833336 19.1666 4.91667 19.1666 10C19.1666 15.0833 15.0833 19.1667 9.99998 19.1667C4.91665 19.1667 0.833313 15.0833 0.833313 10ZM2.49998 10C2.49998 14.1667 5.83331 17.5 9.99998 17.5C14.1666 17.5 17.5 14.1667 17.5 10C17.5 5.83334 14.1666 2.5 9.99998 2.5C5.83331 2.5 2.49998 5.83334 2.49998 10Z",
    fill: "#161616"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1379_7477",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 0.833336C4.91665 0.833336 0.833313 4.91667 0.833313 10C0.833313 15.0833 4.91665 19.1667 9.99998 19.1667C15.0833 19.1667 19.1666 15.0833 19.1666 10C19.1666 4.91667 15.0833 0.833336 9.99998 0.833336ZM9.99998 17.5C5.83331 17.5 2.49998 14.1667 2.49998 10C2.49998 5.83334 5.83331 2.5 9.99998 2.5C14.1666 2.5 17.5 5.83334 17.5 10C17.5 14.1667 14.1666 17.5 9.99998 17.5ZM8.06892 5.66167V6.875H9.15392V14.1667H10.4956V5.66167H8.06892Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1379_7477)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#161616"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberOneIcon);
export default __webpack_public_path__ + "static/media/number-one-icon.61dfec975c5affe724b8026af24575ae.svg";
export { ForwardRef as ReactComponent };